// src/v3/consts/breakpoints.ts
var BREAKPOINTS = {
  small: 320,
  medium: 768,
  large: 1024,
  xLarge: 1280,
  xxLarge: 1440,
  super: 1568,
  ultra: 1920
};
export {
  BREAKPOINTS
};
//# sourceMappingURL=breakpoints.mjs.map